<template>
  <div class="block1200 block1620 ck-content report-cont" style="min-height: 469px;">
    <a-Card>
      <a-form layout="inline" :form="form" @submit="handleSubmit">
        <a-form-item label="订单编号">
          <a-input
            v-decorator="[
            'transactionId',
            {
              initialValue: transactionId,
            },
          ]"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit">
            查询报告
          </a-button>
        </a-form-item>
        <a-form-item>
          
          <div class="Order pull-left">
            注意 ： 请慎重记录并保管好您的 <font color="red">订单号</font> 以便日后查询，离开此页则不再显示
            <a class="WeChat-order" href="javascript:;">
                <img src="../assets/images/reportwx.png">微信订单编号？
                <span><img src="../assets/images/wx_out_trade_num.png" alt=""></span>
            </a>
            <a class="Alipay-order" href="javascript:;">
                <img src="../assets/images//reportzfb.png?v179">支付宝订单编号？
                <span><img src="../assets/images/ali_out_trade_num.png" alt=""></span>
            </a>
        </div>
        </a-form-item>
        
      </a-form>
      <a-divider />
      <a-table 
      :columns="columns" 
      :data-source="result"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      >
        <template slot="checkStatus" slot-scope="text">
          <span v-if="text === 'COMPLETED'">检测完成</span>
          <span v-else>检测中</span>
        </template>
        <span slot="action" slot-scope="text, record">
          <a v-if="record.checkStatus=== 'COMPLETED'" @click="dowZip(`/thesisCheck/api/trade/downReport/${record.tradeId}`)">下载</a>
        </span>
      </a-table>
      <a-alert style="margin-top: 30px; " message="提醒：系统仅保留近7天内的检测报告，请检测完成后尽快下载报告！" type="info" banner />
    </a-Card>
  </div>
</template>

<script>
import { Form, Input, Button, Card, Divider, Alert, Table } from 'ant-design-vue'
import axios from 'axios'
const columns = [
  {
    title: '订单号',
    dataIndex: 'transactionId',
    key: 'transactionId',
  },
  {
    title: '论文标题',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: '作者',
    dataIndex: 'author',
    key: 'author',
  },
  {
    title: '状态结果',
    dataIndex: 'checkStatus',
    key: 'checkStatus',
    scopedSlots: { customRender: 'checkStatus' },
  },
  {
    title: '提交时间',
    key: 'checkTime',
    dataIndex: 'checkTime',
  },
  {
    title: '报告下载',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];

export default {
  components: {
    AForm: Form,
    AFormItem: Form.Item,
    AInput: Input,
    AButton: Button,
    ACard: Card,
    ADivider: Divider,
    ATable: Table,
    AAlert: Alert,
  },
  data() {
    return {
      transactionId: this.$route.params.transactionId || undefined,
      result: [],
      columns,
      pagination: {},
      loading: false,
    }
  },
  created() {
    if(this.transactionId) {
      this.fetch()
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'customized_form_controls' });
  },
  methods: {
    handleTableChange(pagination) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      console.log({
        results: pagination.pageSize,
        page: pagination.current
      })
      this.fetch({
        viewSize: pagination.pageSize,
        viewIndex: pagination.current
      });
    },
    fetch(params = {}) {
      this.loading = true;
      this.$store.dispatch('check/findDataByid', {
        payload: {
          ...params,
          transactionId: this.transactionId,
        },
        callback: (res) => {
          const pagination = { ...this.pagination };
          pagination.total = res.data && res.data.total || 0;
          this.loading = false;
          this.result = res.data && res.data.list || []
          this.pagination = pagination;
        }
      })
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if(values.transactionId) {
            this.transactionId = values.transactionId
            this.fetch()
          } else {
            this.result = []
          }
        }
      });
    },
    dowZip(url, fileName) {
      axios({
        method: 'GET',
        url,
        responseType: 'blob'
      }).then(response => {
        if (navigator.msSaveBlob) {
          // deal with IE 11, data是第一步toBlob的结果值
          window.navigator.msSaveOrOpenBlob(response.data,`${fileName}.zip`);
        }
        else {
          let blob = new Blob([response.data], {type: 'application/zip'})
          let url = window.URL.createObjectURL(blob)
          window.location.href = url
        }
      }).catch(error => this.$message.error(error) )
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .ck-content {
    margin: 20px auto;
  }
  .lists {
    text-align: left;
    width: 1160px;
  }
  .lists .item {
    display: inline-block;
    width: 100%;
    height: 150px;
    position: relative;
  }
  .lists .item.success {
    /*background: url(../assets/check-success.jpg) no-repeat;*/
  }
  .lists .item .status {
    color: #fff;
    padding: 6px 5px;
  }
  .lists .item .oid {
    position: absolute;
    top: 10px;
    left: 90px;
    color: #969696;
  }
  .lists .item .pname {
    color: #202020;
    margin: 10px;
  }
  .lists .item .author, .lists .item .pname {
    color: #202020;
    margin: 10px;
  }
  .lists .item .opr {
    position: absolute;
    right: 20px;
    bottom: 30px;
  }
  .lists .item .opr i {
    font-size: 20px;
    cursor: pointer;
    position: inherit;
  }
  .lists .item .shuiyin {
    position: absolute;
    left: 10px;
    bottom: 25px;
    font-size: 21px;
    color: #bbc3cd;
  }

  .Order a {
      color: #525252;
      position: relative;
      margin-left: 40px;
  }
  .Order a:first-child {
    margin-left: 0;
  }
  .Order img {
    padding-right: 10px;
  }
  .Order span {
    position: absolute;
    top: 30px;
    right: -200px;
    display: none;
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 10px 2px #efefef;
    z-index: 2;
  } 
  .Order a:hover span {
      display: block;
  }
  .Order span{
    position:absolute;
    top:30px;
    right:-200px;
    display:none;
    padding:20px;
    background:#fff;
    box-shadow:0 0 10px 2px #efefef;
    z-index:2
  }

  .Order span:before {
      position: absolute;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-bottom: 9px solid #efefef;
      content: " ";
      display: block;
      width: 0;
      height: 0;
      top: -10px;
      right: 280px;
  }
  .Order span:after {
      border-bottom: 9px solid #fff;
      top: -8px;
  }
</style>
